import { render, staticRenderFns } from "./EnrolmentOrganisationInterest.vue?vue&type=template&id=49cb40a5&scoped=true&"
import script from "./EnrolmentOrganisationInterest.vue?vue&type=script&lang=js&"
export * from "./EnrolmentOrganisationInterest.vue?vue&type=script&lang=js&"
import style0 from "./EnrolmentOrganisationInterest.vue?vue&type=style&index=0&id=49cb40a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cb40a5",
  null
  
)

export default component.exports